// src/icon/src/types/index.tsx
import { cva } from "class-variance-authority";
var icon = cva(null, {
  variants: {
    category: {
      essentials: ["bg-tertiary-1", "text-primary-1"],
      general: ["bg-tertiary-5", "text-primary-5"],
      income: ["bg-tertiary-4", "text-primary-4"],
      non_essentials: ["bg-tertiary-6", "text-primary-6"],
      one_off_transactions: ["bg-tertiary-7", "text-primary-7"],
      plain: ["bg-surface-subtle", "text-surface-body"],
      transfers: ["bg-tertiary-2", "text-primary-2"]
    },
    size: {
      // pixel values used in the icon viewbox
      lg: ["64"],
      md: ["40"],
      sm: ["24"]
    }
  }
});

export {
  icon
};
